<template>
	<div>
		<div class="jinbu flex  align-items align-content">
			<div class="pointer" >首页</div>
		</div>
		<div class="w1200" style="padding: 20px;">
			
			<div class="flex benben-flex-layout flex-wrap align-center">
				<div class="video_0 margin_left">本周期时间筛选：</div>
				<el-select class="video_1" v-model="value1" placeholder="请选择" filterable >
					<el-option
					  v-for="item in options1"
					  :key="item.value"
					  :label="item.label"
					  :value="item.value">
					</el-option>
				</el-select>
				 <el-date-picker class="video_1" v-if="value1 == 1" @change="post691d8833217bb"
				      value-format="yyyy-MM-dd"
				      v-model="value2"
				      type="date"
					  :picker-options="pickerOptions3"
				      placeholder="选择日期">
				</el-date-picker>
				 <el-date-picker class="video_1" v-if="value1 == 2" @change="post691d8833217bb"
				      v-model="value3"
					  value-format="yyyy-MM"
				      type="month"
					  :picker-options="pickerOptions3"
				      placeholder="选择月">
				</el-date-picker>
				<el-date-picker class="video_1" v-if="value1 == 3" @change="post691d8833217bb"
				      v-model="value4"
					  value-format="yyyy"
				      type="year"
					  :picker-options="pickerOptions3"
				      placeholder="选择年">
				</el-date-picker>
			</div>
			<div class="index_0 flex">
				<div class="flex benben-flex-layout flex-wrap align-center index_1">
					<div class="flex-sub">
						<div class="index_3">卡片总数</div>
						<div class="index_4">{{detail.all_num || 0}}</div>
						<!-- <div class="flex index_5">
							<div class="index_5_1">同比</div>
							<div class="flex benben-flex-layout flex-wrap align-center index_5_4">
								<img class="index_5_2" src="../../static/image/29.png" alt="" srcset="">
								<div class="index_5_3">14.5%</div>
							</div>
						</div>
						<div class="flex index_5">
							<div class="index_5_1">环比</div>
							<div class="flex benben-flex-layout flex-wrap align-center index_5_4">
								<img class="index_5_2" src="../../static/image/30.png" alt="" srcset="">
								<div class="index_5_3">14.5%</div>
							</div>
						</div> -->
					</div>
					<img class="index_2" src="../../static/image/27.png" alt="" srcset="">
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center index_1 index_1_0">
					<div class="flex-sub">
						<div class="index_3">卡片激活数</div>
						<div class="index_4">{{detail.activate_num || 0}}</div>
						<!-- <div class="flex index_5">
							<div class="index_5_1">同比</div>
							<div class="flex benben-flex-layout flex-wrap align-center index_5_4">
								<img class="index_5_2" src="../../static/image/29.png" alt="" srcset="">
								<div class="index_5_3">14.5%</div>
							</div>
						</div>
						<div class="flex index_5">
							<div class="index_5_1">环比</div>
							<div class="flex benben-flex-layout flex-wrap align-center index_5_4">
								<img class="index_5_2" src="../../static/image/30.png" alt="" srcset="">
								<div class="index_5_3">14.5%</div>
							</div>
						</div> -->
					</div>
					<img class="index_2" src="../../static/image/28.png" alt="" srcset="">
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center index_1 index_1_1">
					<div class="flex-sub">
						<div class="index_3">卡片未激活数</div>
						<div class="index_4">{{detail.no_activate_num || 0}}</div>
						<!-- <div class="flex index_5">
							<div class="index_5_1">同比</div>
							<div class="flex benben-flex-layout flex-wrap align-center index_5_4">
								<img class="index_5_2" src="../../static/image/29.png" alt="" srcset="">
								<div class="index_5_3">14.5%</div>
							</div>
						</div>
						<div class="flex index_5">
							<div class="index_5_1">环比</div>
							<div class="flex benben-flex-layout flex-wrap align-center index_5_4">
								<img class="index_5_2" src="../../static/image/30.png" alt="" srcset="">
								<div class="index_5_3">14.5%</div>
							</div>
						</div> -->
					</div>
					<img class="index_22" src="../../static/image/31.png" alt="" srcset="">
				</div>
			</div>
			<div>
				<div ref="lineChart" style="width: 100%; height: 400px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	// 引入ECharts主模块
	import * as echarts from 'echarts/core';
	// 引入折线图图表，图表后缀都为 Chart
	import { LineChart } from 'echarts/charts';
	// 引入提示框和标题组件，组件后缀都为 Component
	import { TitleComponent, TooltipComponent, GridComponent,LegendComponent } from 'echarts/components';
	// 引入Canvas渲染器
	import { CanvasRenderer } from 'echarts/renderers';
	
	// 注册必须的组件
	echarts.use([TitleComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer,LegendComponent]);
	export default {
		components: {},
		data() {
			return {
				options1:[
					{
					  value: '1',
					  label: '日'
					}, {
					  value: '2',
					  label: '月'
					}, {
					  value: '3',
					  label: '年'
					}
				],
				value1: '1',
				value2:'',
				pickerOptions3:{
					disabledDate(time) { 
					    // 禁止选择未来日期（不能选择今天）
					    return time.getTime() > Date.now() ;
					},
				},
				value3:'',
				value4:'',
				detail:'',
			}
		},
		created() {
			if(this.value1 == 1){
				// 创建Date对象
				const today = new Date()
				// 获取年份[citation:3][citation:5]
				const year = today.getFullYear()
				// 获取月份（注意：getMonth()返回0-11，需+1）[citation:3][citation:5]
				const month = String(today.getMonth() + 1).padStart(2, '0') // 补零
				// 获取日期[citation:3][citation:5]
				const day = String(today.getDate()).padStart(2, '0') // 补零
				this.value2 = year+'-'+month+'-'+day
			}
			 
			this.post691d8833217bb()
		},
		
		mounted() {
		 
		},
		methods:{
			// 列表数据
			post691d8833217bb(){
				this.$api.post(this.$apiUrls.post691d8833217bb, {
					type:this.value1,
					date:this.value1 == 1 ? this.value2 : (this.value1 == 2 ? this.value3 : this.value4)
				}).then((res) => {
					// console.log(res, 123)
					if (res.code == 1) {
						this.detail = res.data
						if(this.detail.lest.list && this.detail.lest.list.length > 0){
							for (var i = 0; i < this.detail.lest.list.length; i++) {
								this.detail.lest.list[i].type = 'line'
								this.detail.lest.list[i].stack = this.detail.lest.list[i].name
							}
						}else{
							this.detail.lest.list = [
									{
										name: '卡片总数',
										type: 'line', // 类型为折线图
										stack: '卡片总数', // 堆叠名称，相同stack值的线条会堆叠在一起，这里是堆叠到一起显示，形成一个总体趋势图。
										data: [] // 系列中的数据内容数组。
									},
									{
										name: '卡片激活数',
										type: 'line', // 类型为折线图，与上面同理。
										stack: '卡片激活数', // 与上面的系列堆叠在一起。
										data: [] // 系列中的数据内容数组。与上面的系列相对应。
									},
									{
										name: '卡片未激活数',
										type: 'line', // 类型为折线图，与上面同理。
										stack: '卡片未激活数', // 与上面的系列堆叠在一起。
										data: [] // 系列中的数据内容数组。与上面的系列相对应。
									},
									// 可以继续添加更多的系列数据...
								]
						}
						
						this.$nextTick(() => {
							this.initLineChart();
						})
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			initLineChart() {
				const myChart = echarts.init(this.$refs.lineChart);
				console.log(this.detail.lest.list,1111111111111)
				const option = {
					title: {
						text: ''
					},
					tooltip: {
						trigger: 'axis'
					},
					color: ['#004EA1', '#7EC743', '#333333'], // 定义颜色数组
					legend: { 
						// orient: 'vertical',
						padding: [0, 0, 350, 0],
						data: ['卡片总数', '卡片激活数', '卡片未激活数'] ,
					},
				
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false, // 坐标轴两边留白策略，默认为true，类目轴和非类目轴的设置不一样。
						data: this.detail.lest.time || ''
						// data: ['1','2','3',4,5,6,7]
					},
					yAxis: {
						type: 'value'
					},
					series:this.detail.lest.list,
					// series: [
					// 	{
					// 		name: '卡片总数',
					// 		type: 'line', // 类型为折线图
					// 		stack: '卡片总数', // 堆叠名称，相同stack值的线条会堆叠在一起，这里是堆叠到一起显示，形成一个总体趋势图。
					// 		data: [120, 132, 101, 134, 90, 230, 210] // 系列中的数据内容数组。
					// 	},
					// 	{
					// 		name: '卡片激活数',
					// 		type: 'line', // 类型为折线图，与上面同理。
					// 		stack: '卡片激活数', // 与上面的系列堆叠在一起。
					// 		data: [220, 182, 191, 234, 290, 330, 310] // 系列中的数据内容数组。与上面的系列相对应。
					// 	},
					// 	{
					// 		name: '卡片未激活数',
					// 		type: 'line', // 类型为折线图，与上面同理。
					// 		stack: '卡片未激活数', // 与上面的系列堆叠在一起。
					// 		data: [210, 202, 151, 204, 300, 90, 210] // 系列中的数据内容数组。与上面的系列相对应。
					// 	},
					// 	// 可以继续添加更多的系列数据...
					// ]
				};
				myChart.setOption(option); // 将配置项设置给echarts实例。
			}
		},
	}
</script>

<style  lang="scss" scoped>
	::v-deep {
		.video_1{
			width: 200px;
			height: 32px;
			margin-right: 32px;
		}
		.video_1 .el-input__inner {
			height: 32px;
		}
		.video_1 .el-icon-circle-close,
		.video_1 .el-icon-arrow-up{
			line-height: 32px !important;
		}
		.video_1 .el-icon-date{
			line-height: 32px !important;
		}
	}
	.video_0{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.index_0{
		margin: 20px 0 0 0;
	}
	.index_1{
		width: 400px;
		height: 178px;
		background: #E5F2FF;
		border-radius: 16px 16px 16px 16px;
		padding:0 0 0 30px;
	}
	.index_1_0{
		background: #F2F9EC;
		margin: 0 20px;
	}
	.index_1_1{
		background: #EEEEEE;
	}
	.index_2{
		width: 170px;
		height: 79px;
		margin: 0 10px 0 20px;
	}
	.index_22{
		width: 110px;
		height: 110px;
		margin: 0 10px 0 20px;
	}
	.index_3{
		font-weight: 500;
		font-size: 18px;
		color: #333333;
		// margin: 20px 0 0 0;
	}
	.index_4{
		font-weight: 800;
		font-size: 30px;
		color: #000000;
	}
	.index_5{
		margin-top: 10px;
	}
	.index_5_1{
		font-weight: 400;
		font-size: 14px;
		color: #80879C;
	}
	.index_5_2{
		width: 12px;
		height: 12px;
	}
	.index_5_3{
		font-weight: 400;
		font-size: 14px;
		color: #000000;
	}
	.index_5_4{
		margin: 0 0 0 auto;
	}
</style>